/**
 * @file helper module for calendar
 * @author tobias.frei@notch-interactive.com
 *
 * @module components/calendar/filter-helper
 */

import model from './filter-model';
import ui from './filter-ui';

const instance = {};


// /**
//  * encode a string in base-64
//  *
//  * @param {string} str - string to encode
//  * @return {string} - encoded base64 string
//  */
// instance.btoa = (str) => {
//     return window.btoa(str);
// };


/**
 * get year from unix timestamp
 *
 * @param {number} unixTimestamp - unix timestamp
 * @return {string} - string of year
 */
instance.getYear = (unixTimestamp) => {
    let isoString = new Date(unixTimestamp * 1000).toISOString().split('T')[0]; // convert unix to js timestamp

    return isoString.split('-')[0];
};


/**
 * get day from unix timestamp
 *
 * @param {number} unixTimestamp - unix timestamp
 * @return {string} - string of day
 */
instance.getDay = (unixTimestamp) => {
    let isoString = new Date(unixTimestamp * 1000).toISOString().split('T')[0]; // convert unix to js timestamp

    return isoString.split('-')[2];
};


/**
 * get month from unix timestamp
 *
 * @param {number} unixTimestamp - unix timestamp
 * @return {string} - string of month
 */
instance.getMonth = (unixTimestamp) => {
    let isoString = new Date(unixTimestamp * 1000).toISOString().split('T')[0];

    return window.DS.translations.months[parseInt(isoString.split('-')[1]) - 1];
};


/**
 * update breakpoint specific data
 *
 * @return {void}
 */
instance.getBreakpoint = () => {
    let vw = window.innerWidth || document.body.clientWidth,
        reverseGridObj = Object.keys(model.settings.grid).reverse();

    for (let key in reverseGridObj) {
        if (reverseGridObj.hasOwnProperty(key)) {
            if (vw >= parseInt(reverseGridObj[key])) {
                model.calendar.queryAmount = model.settings.grid[reverseGridObj[key]].initalRows * model.settings.grid[reverseGridObj[key]].itemsOnRow;
                model.calendar.queryStep = model.settings.grid[reverseGridObj[key]].moreRows * model.settings.grid[reverseGridObj[key]].itemsOnRow;
                model.calendar.itemsOnRow = model.settings.grid[reverseGridObj[key]].itemsOnRow;
                break;
            }
        }
    }
};


/**
 * check filter categories for blank data
 *
 * @param {Array} filterArr - array of filters
 * @return {Array} - array of filters
 */
instance.checkCatArray = (filterArr) => {
    if (filterArr.length < 1) {
        filterArr = calendar.option.getFilterData;
    }
    return filterArr;
};


/**
 * check for body click
 *
 * @param {object} e - click event
 * @return {void}
 */
instance.bodyclick = (e) => {
    if (e.target.closest('.filterbar__payload') === null) {
        ui.closeNav();
    }
};


/**
 * listen for transition callback
 *
 * @param {object} e - transition end event
 * @return {void}
 */
instance.transitionListener = (e) => {
    e.target.removeEventListener('transitionend', instance.transitionListener, false);

    if (e.propertyName === 'height') {
        e.target.callbackFunctions.forEach((func, index) => {
            func(e.target.args[index]);
        });
    }
};


/**
 * calc unix timestamp range from year
 *
 * @param {string} y - year to convert
 * @return {Array} - array with start and end timestamp
 */
instance.getTimestampFromYear = (y) => {
    let startDate = Date.parse(y + '/01/01 00:00:00 GMT') / 1000,
        endDate = Date.parse(y + '/12/31 23:59:59 GMT') / 1000,
        retArr = [];

    retArr.push(new Date(startDate).getTime());
    retArr.push(new Date(endDate).getTime());

    return retArr;
};


/**
 * calc unix timestamp range from month
 *
 * @param {string} m - month to convert
 * @param {string} y - year of month
 * @return {Array} - array with start and end timestamp
 */
instance.getTimestampFromMonth = (m, y) => {
    let dayAmount = 32 - new Date(y, m - 1, 32).getDate(),
        startDate = Date.parse(y + '/' + m + '/01 00:00:00 GMT') / 1000,
        endDate = Date.parse(y + '/' + m + '/' + dayAmount + ' 23:59:59 GMT') / 1000,
        retArr = [];

    retArr.push(new Date(startDate).getTime());
    retArr.push(new Date(endDate).getTime());

    return retArr;
};


/**
 * Calculate if timestamps have one day difference
 *
 * @param {number} startTime - first timestamp
 * @param {number} endTime - second timestamp
 * @return {boolean} - is difference one day
 */
instance.oneDayDiff = (startTime, endTime) => {
    let diffHours = (endTime - startTime) / 60 / 60;

    return diffHours >= 24 && diffHours < 48;
};


/**
 * debug date form timestamp
 *
 * @param {number} unixTimestamp - unix timestamp
 * @return {string} - date from unix stamp
 */
instance.debugDate = (unixTimestamp) => {
    return new Date(unixTimestamp * 1000).toISOString();
};


/**
 * resize event
 *
 * @return {void}
 */
instance.resize = () => {
    if (document.documentElement.clientWidth === model.resizeWidth) {
        return;
    }

    model.calendar.closeAllTiles();
    model.calendar.closeAllSublevels();

    setTimeout(() => {
        model.calendar.getBreakpoint();
        model.calendar.setTileStyles();
        model.resizeWidth = document.documentElement.clientWidth;
        model.calendar.$refs.cpt.sort(model.calendar.option.sortBy);
    }, 0);
};


/**
 * get translations
 *
 * @param {string} key - reference key on translation object
 * @return {string} - translation
 */
instance.getTranslation = (key) => {
    return window.DS.translations[key];
};


export default instance;
